<template>
    <div class="horizontal-separator" />
</template>

<script>
export default {
    name: 'HorizontalSeparator'
}
</script>
